import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { InquiryCommentRow, InquiryResponse } from '@models/inquiry';
import dayjs from 'dayjs';

import CounselorIcon from './CounselorIcon';
import styles from './styles.module.scss';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryComments({ inquiry }:Props) {
  const { comments } = inquiry;
  return (
        <Column fullWidth
                className={styles.list}>
            {comments.sort(
              (a, b) => dayjs(a.createdAt).diff(dayjs(b.createdAt)),
            ).map((comment, i) => (
                <InquiryComment key={comment.id}
                                comment={comment}/>
            ))}
        </Column>
  );
}

interface CommentProps {
    comment: InquiryCommentRow;
}

function InquiryComment({ comment }: CommentProps) {
  const {
    content, authorType, createdAt, fileUrls,
  } = comment;
  const isMine = authorType === 'CUSTOMER';
  return (
      <Row fullWidth spacing={14}
           align='flex-start'
                className={styles.container}>
          {(!isMine) && (
              <CounselorIcon/>
          )}
          <Column fullWidth>
              <Text color={colors.gray6} className={styles.content}
                    dangerouslySetInnerHTML={{ __html: content }}
                    as='div' />
              {(fileUrls && fileUrls.length !== 0) && (
                  <Images>
                      {fileUrls.map((fileUrl) => (
                          <Image src={fileUrl}
                                 key={fileUrl}/>
                      ))}
                  </Images>
              )}
              <Row justify='flex-end' fullWidth className={styles.date}>
                  <Text color={colors.gray6}>
                      {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
                  </Text>
              </Row>
          </Column>
      </Row>
  );
}

const Images = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
    img {
        width: 100%;
    }
`;

export default InquiryComments;
